// 드롭다운 옵션 상수 정의
export const INDUSTRY_OPTIONS = [
  { code: "finance", name: "금융/은행" },
  { code: "callCenter", name: "콜센터/BPO" },
  { code: "distribution", name: "유통/커머스" },
  { code: "it", name: "IT/소프트웨어" },
  { code: "manufacturing", name: "제조/자동차" },
  { code: "public", name: "공공/교육" },
  { code: "healthcare", name: "헬스케어/의료" },
  { code: "broadcast", name: "미디어/방송" },
  { code: "logistics", name: "물류/운송" },
  { code: "other", name: "기타" }
] as const;

export const POSITION_OPTIONS = [
  { code: "cLevel", name: "C-level(CEO/CTO/COO/CMO 등)" },
  { code: "headExecutive", name: "부서장/임원(상무/이사/본부장 등)" },
  { code: "teamLeader", name: "팀장/파트장" },
  { code: "manager", name: "매니저/PM" },
  { code: "seniorExecutive", name: "주임/선임/실무" },
  { code: "crew", name: "담당자/팀원" },
  { code: "other", name: "기타" }
] as const;

export const ROLE_OPTIONS = [
  { code: "it", name: "IT/개발(Engineer/DevOps/Backend/Frontend 등)" },
  { code: "ai", name: "AI/데이터 분석" },
  { code: "operations", name: "운영/기획/서비스 총괄" },
  { code: "customerSupport", name: "CS/고객지원/상담" },
  { code: "marketing", name: "마케팅/브랜드" },
  { code: "sales", name: "영업/사업개발" },
  { code: "hrFinance", name: "인사/총무/재무" },
  { code: "other", name: "기타" }
] as const;

export const COMPANY_SIZE_OPTIONS = [
  { code: "S1", name: "1~49명" },
  { code: "S2", name: "50~299명" },
  { code: "S3", name: "300~999명" },
  { code: "S4", name: "1,000명 이상" }
] as const;

// 타입 정의
export type IndustryCode = typeof INDUSTRY_OPTIONS[number]['code'];
export type IndustryName = typeof INDUSTRY_OPTIONS[number]['name'];
export type PositionCode = typeof POSITION_OPTIONS[number]['code'];
export type PositionName = typeof POSITION_OPTIONS[number]['name'];
export type RoleCode = typeof ROLE_OPTIONS[number]['code'];
export type RoleName = typeof ROLE_OPTIONS[number]['name'];
export type CompanySizeCode = typeof COMPANY_SIZE_OPTIONS[number]['code'];
export type CompanySizeName = typeof COMPANY_SIZE_OPTIONS[number]['name'];

// 유틸리티 함수들 (타입 안전성 개선)
export const getIndustryCodeByName = (name: string): IndustryCode => {
  const option = INDUSTRY_OPTIONS.find(opt => opt.name === name);
  return option ? option.code : "other";
};

export const getIndustryNameByCode = (code: string): IndustryName => {
  const option = INDUSTRY_OPTIONS.find(opt => opt.code === code);
  return option ? option.name : "기타";
};

export const getPositionCodeByName = (name: string): PositionCode => {
  const option = POSITION_OPTIONS.find(opt => opt.name === name);
  return option ? option.code : "other";
};

export const getPositionNameByCode = (code: string): PositionName => {
  const option = POSITION_OPTIONS.find(opt => opt.code === code);
  return option ? option.name : "기타";
};

export const getRoleCodeByName = (name: string): RoleCode => {
  const option = ROLE_OPTIONS.find(opt => opt.name === name);
  return option ? option.code : "other";
};

export const getRoleNameByCode = (code: string): RoleName => {
  const option = ROLE_OPTIONS.find(opt => opt.code === code);
  return option ? option.name : "기타";
};

export const getCompanySizeCodeByName = (name: string): CompanySizeCode => {
  const option = COMPANY_SIZE_OPTIONS.find(opt => opt.name === name);
  return option ? option.code : "S1";
};

export const getCompanySizeNameByCode = (code: string): CompanySizeName => {
  const option = COMPANY_SIZE_OPTIONS.find(opt => opt.code === code);
  return option ? option.name : "1~49명";
};

// 이름만 추출한 배열들 (드롭다운용)
export const INDUSTRY_NAMES = INDUSTRY_OPTIONS.map(option => option.name);
export const POSITION_NAMES = POSITION_OPTIONS.map(option => option.name);
export const ROLE_NAMES = ROLE_OPTIONS.map(option => option.name);
export const COMPANY_SIZE_NAMES = COMPANY_SIZE_OPTIONS.map(option => option.name);
